import { IconButton, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import WhiteCard from "src/shared/components/WhiteCard";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useGetActiveFilesQuery } from "src/api/services/bucketApi";
import { useTranslation } from "react-i18next";

interface FitnessAndNutritionProps {
  page: string;
}

const FitnessAndNutrition = ({ page }: FitnessAndNutritionProps) => {
  const { data } = useGetActiveFilesQuery("resources");
  const fitnessComponent = "fitnessPlan";
  const nutritionComponent = "nutritionPlan";
  const { t } = useTranslation();

  const fitnessPlan = useMemo(() => {
    if (data == null) return [];

    return data.find((f) => f.title === "Fitness")?.url;
  }, [data]) as string;

  const nutritionPlan = useMemo(() => {
    if (data == null) return [];

    return data.find((f) => f.title === "Nutrition")?.url;
  }, [data]) as string;

  return (
    <Stack gap={2}>
      <WhiteCard
        gap={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack gap={1}>
          <Typography fontWeight={600} role="heading">
            {t(`${page}.${fitnessComponent}.header`)}
          </Typography>
          <Typography variant="body2">
            {t(`${page}.${fitnessComponent}.text`)}
          </Typography>
        </Stack>
        <IconButton size="small">
          <a href={fitnessPlan} target="_blank">
            <NavigateNextIcon sx={{ color: "#00B6B9" }} fontSize="medium" />
          </a>
        </IconButton>
      </WhiteCard>
      <WhiteCard
        gap={1}
        justifyContent="space-between"
        direction="row"
        alignItems="center"
      >
        <Stack gap={1}>
          <Typography fontWeight={600} role="heading">
            {t(`${page}.${nutritionComponent}.header`)}
          </Typography>
          <Typography variant="body2">
            {t(`${page}.${nutritionComponent}.text`)}
          </Typography>
        </Stack>
        <IconButton size="small">
          <a href={nutritionPlan} target="_blank">
            <NavigateNextIcon sx={{ color: "#00B6B9" }} fontSize="medium" />
          </a>
        </IconButton>
      </WhiteCard>
    </Stack>
  );
};

export default FitnessAndNutrition;
